'use strict';

const submitCartForm = ev => {
  window.DealEventPipe.trigger('cartFormSubmit', ev);
};

const updateCartForm = (dealUuid, optionUuid) => {
  window.DealEventPipe.trigger('cartFormInitialize', {
    dealUuid,
    uuid: optionUuid,
  });
};

const updateAndSubmitCartForm = ({ dealUuid, optionUuid }, ev) => {
  updateCartForm(dealUuid, optionUuid);
  submitCartForm(ev);
};

const getDealData = element => {
  const { deal: dealUuid, uuid: optionUuid } = element.dataset;

  return {
    dealUuid,
    optionUuid,
  };
};

const shouldSkipCartForBookingOption = (event, optionUuid) => {
  const bookableOptionUuids =
    window.DealData.onlineBooking?.bookableOptionUuids;
  if (!bookableOptionUuids || !Array.isArray(bookableOptionUuids)) return false;
  return (
    event.currentTarget.tagName === 'A' &&
    bookableOptionUuids.indexOf(optionUuid) > -1
  );
};

const addCartHandler = function addCartHandler(cart, isTouch = false) {
  if (!cart || !document.querySelector('#goods-add-to-cart-form')) {
    return;
  }
  const { dealUuid } = cart;

  this.eventPipe.on('option_updated', ({ optionUuid }) => {
    updateCartForm(dealUuid, optionUuid);
  });

  if (isTouch) {
    const activeModalOptionEls = document.querySelectorAll(
      'ul.option-list li:not(.sold-out) a'
    );
    for (let i = 0; i < activeModalOptionEls.length; i++) {
      activeModalOptionEls[i].addEventListener('click', event => {
        const { optionUuid } = getDealData(event.currentTarget);
        if (shouldSkipCartForBookingOption(event, optionUuid)) {
          // HACK to fix the booking flow for deals with more than 4+ options
          // more details on https://jira.groupondev.com/browse/CBE-778
          return;
        }
        event.preventDefault();
        updateAndSubmitCartForm({ dealUuid, optionUuid }, event);
      });
    }
  }
};

module.exports = { addCartHandler, updateAndSubmitCartForm };
